import React, { useEffect, useState } from 'react';
import { Link, NavLink, useLocation } from 'react-router-dom';
import {
  FaBars,
  FaTimes,
  FaHome,
  FaUsers,
  FaBox,
  FaCalendarAlt,
  FaFileInvoice,
  FaMoneyBillWave,
  FaChalkboardTeacher
} from 'react-icons/fa';
import logo from '../assets/logo.png';
import './Navbar.css';

function Navbar() {
  const [isOpen, setIsOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    setIsOpen(false);
  }, [location.pathname]);

  useEffect(() => {
    document.body.classList.toggle('mobile-nav-open', isOpen);
    return () => {
      document.body.classList.remove('mobile-nav-open');
    };
  }, [isOpen]);

  const navItems = [
    { label: 'Dashboard', path: '/admin', icon: <FaHome /> },
    { label: 'Students', path: '/students', icon: <FaUsers /> },
    { label: 'Teachers', path: '/teachers', icon: <FaChalkboardTeacher /> },
    { label: 'Products', path: '/products', icon: <FaBox /> },
    { label: 'Batches', path: '/batches', icon: <FaCalendarAlt /> },
    { label: 'Enrollments', path: '/enrollments', icon: <FaUsers /> },
    { label: 'Attendance', path: '/attendance', icon: <FaCalendarAlt /> },
    { label: 'Invoices', path: '/invoices', icon: <FaFileInvoice /> },
    { label: 'Payments', path: '/payments', icon: <FaMoneyBillWave /> }
  ];

  return (
    <nav className={`navbar ${isOpen ? 'menu-open' : ''}`}>
      <div className="navbar-container">
        <Link to="/admin" className="navbar-logo">
          <span className="navbar-logo-mark">
            <img src={logo} alt="Epsilon Skating Club" />
          </span>
          <span className="navbar-logo-copy">
            <strong>Epsilon Skating Club</strong>
            <small>Club Admin</small>
          </span>
        </Link>

        <button
          type="button"
          className="hamburger"
          onClick={() => setIsOpen((current) => !current)}
          aria-expanded={isOpen}
          aria-label={isOpen ? 'Close navigation menu' : 'Open navigation menu'}
        >
          {isOpen ? <FaTimes /> : <FaBars />}
        </button>

        <button
          type="button"
          className={`nav-backdrop ${isOpen ? 'active' : ''}`}
          aria-label="Close navigation menu"
          onClick={() => setIsOpen(false)}
        />

        <ul className={`nav-menu ${isOpen ? 'active' : ''}`}>
          {navItems.map((item) => (
            <li className="nav-item" key={item.path}>
              <NavLink
                to={item.path}
                className={({ isActive }) => `nav-link${isActive ? ' active' : ''}`}
                onClick={() => setIsOpen(false)}
              >
                <span className="nav-icon">{item.icon}</span>
                {item.label}
              </NavLink>
            </li>
          ))}
        </ul>
      </div>
    </nav>
  );
}

export default Navbar;
